export const CUSTOM_MEDIA_VAR_ID_START = 100;